import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import React from 'react'

import CustomDialog from 'shared/components/CustomDialog'

import DeleteLocationModal from './components/DeleteLocationModal'
import NewLocationModal from './components/NewLocationModal'
import { FormType } from '../../types'

interface Props {
   open: boolean
   type?: FormType
   handleClose: () => void
   country?: string
   locationUuid?: string
}

export default function Modal({ open, type, handleClose, locationUuid, country }: Props) {
   const { t } = useTranslation('TRANSLATION')

   function renderForm() {
      switch (type) {
         case 'newLocation':
            return <NewLocationModal country={country} handleClose={handleClose} />
         case 'deleteLocation':
            return <DeleteLocationModal locationUuid={locationUuid} handleClose={handleClose} />
         default:
            return null
      }
   }
   return (
      <CustomDialog
         open={open}
         onClose={handleClose}
         isLoading={!open}
         deleteVariant={type === 'deleteLocation'}
         content={
            <>
               <DialogTitle>{t(`LOCATIONS:${type}`)}</DialogTitle>
               {renderForm()}
            </>
         }
      />
   )
}
